import { useEffect, useRef, useState } from 'react';
import { testimonials } from '@/mocks/testimonials';

export default function TestimonialSection() {
  const [current, setCurrent] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setInterval>>();

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setCurrent((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(intervalRef.current);
  }, []);

  const prev = () => setCurrent((c) => (c - 1 + testimonials.length) % testimonials.length);
  const next = () => setCurrent((c) => (c + 1) % testimonials.length);

  const t = testimonials[current];

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="font-heading text-2xl md:text-3xl text-foreground-300">
              &ldquo;读者真实评价&rdquo;
            </span>
          </div>

          <div className="bg-background-50 rounded-2xl border border-background-200/70 p-8 md:p-12 relative">
            <div className="flex items-center gap-2 mb-6">
              <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-foreground-900 text-background-50">
                <i className="ri-star-fill text-accent-500 text-sm"></i>
                <span className="text-sm font-medium">{t.rating}</span>
              </div>
              <span className="text-xs text-foreground-400">{t.source}</span>
            </div>

            <blockquote className="text-lg md:text-xl text-foreground-700 leading-relaxed font-heading italic mb-8">
              &ldquo;{t.comment}&rdquo;
            </blockquote>

            <div className="flex items-center gap-3">
              <img
                src={t.avatarUrl}
                alt={t.name}
                className="w-12 h-12 rounded-full object-cover"
              />
              <div>
                <p className="text-sm font-semibold text-foreground-800">{t.name}</p>
                <p className="text-xs text-foreground-400">资深漫画读者</p>
              </div>
            </div>

            <div className="absolute bottom-8 right-8 md:bottom-12 md:right-12 flex items-center gap-1">
              <button
                onClick={prev}
                className="w-10 h-10 rounded-lg border border-background-300/60 flex items-center justify-center text-foreground-600 hover:bg-background-100 transition-colors cursor-pointer"
                aria-label="上一条评价"
              >
                <i className="ri-arrow-left-s-line"></i>
              </button>
              <button
                onClick={next}
                className="w-10 h-10 rounded-lg bg-foreground-900 flex items-center justify-center text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer"
                aria-label="下一条评价"
              >
                <i className="ri-arrow-right-s-line"></i>
              </button>
            </div>
          </div>

          <div className="flex items-center justify-center gap-2 mt-6">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrent(i)}
                className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                  i === current
                    ? 'w-6 bg-primary-500'
                    : 'bg-background-300 hover:bg-background-400'
                }`}
                aria-label={`切换到第${i + 1}条评价`}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}